import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import { useBasket } from '~/features/basket';
import { HomePageSchema } from '~/features/standard-page/components/HomePageSchema';
import { Modules, P20FrontPage as P20FrontPageType } from '~/lib';
import { ProductItemBasket } from '~/lib/data-contract/salesforce';
import { useTranslation } from '~/shared/utils/translation';
import { DynamicBlockList } from '~/templates/blocks';
import { notifyError, notifyInfo } from '~/shared/utils/errorBoundary/toast';

export const P20FrontPage = (props: P20FrontPageType) => {
    const { pageElements, bottomPageElements } = props;
    const router = useRouter();
    const basket = useBasket();
    const { translate } = useTranslation();
    const hasProcessed = useRef(false);

    const parseDecodedString = (str: string): ProductItemBasket[] => {
        return str.split(';').map((item) => {
            const [quantity, id] = item.split(',');
            return { quantity: Number(quantity), productId: id };
        });
    };

    useEffect(() => {
        if (!router.isReady || !basket.loaded || hasProcessed.current) return;

        const processUrlParams = async () => {
            const encodedData = router.query.data as string;

            if (!encodedData) return;

            hasProcessed.current = true;

            let parsedData: ProductItemBasket[];

            try {
                const decoded = atob(encodedData);
                parsedData = parseDecodedString(decoded);
            } catch (error) {
                console.error('Error decoding or parsing data:', error);
                return;
            }

            try {
                const result = await basket.basketAddItemFromIpaper(parsedData);

                if (result) {
                    notifyInfo(translate('basket.addToBasketSuccessFromCatalogues'));
                }
            } catch (error) {
                notifyError(new Error(translate('basket.addToBasketErrorFromCatalogues')));
                console.error(
                    'No item added to basket due to items being out of stock, invalid, or unknnown',
                    error,
                );
            } finally {
                router.replace('/');
            }
        };

        processUrlParams();
    }, [router.isReady, router.query.data, basket.loaded]);

    return (
        <>
            <HomePageSchema />

            <DynamicBlockList elements={pageElements as Modules[]} />
            <DynamicBlockList elements={bottomPageElements as Modules[]} />
        </>
    );
};
